var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.disabled
    ? _c(
        "div",
        [
          _vm._l(_vm.tags, function (item) {
            return _c(
              "yxt-tag",
              { key: item.id, attrs: { type: "info", size: "small" } },
              [_vm._v("\n    " + _vm._s(item.tagName) + "\n  ")]
            )
          }),
          _vm.tags.length === 0 ? _c("span", [_vm._v("--")]) : _vm._e(),
        ],
        2
      )
    : _c("yxtbiz-tag", {
        staticClass: "v-mid kng-upload-tag d-in-block-im wp-100",
        attrs: {
          width: "100%",
          required: "",
          clearAfterAdded: "",
          module: 101,
        },
        model: {
          value: _vm.tags,
          callback: function ($$v) {
            _vm.tags = $$v
          },
          expression: "tags",
        },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }